import { render, staticRenderFns } from "./ModelBar.vue?vue&type=template&id=54626daf&scoped=true&"
import script from "./ModelBar.vue?vue&type=script&lang=js&"
export * from "./ModelBar.vue?vue&type=script&lang=js&"
import style0 from "./ModelBar.vue?vue&type=style&index=0&id=54626daf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54626daf",
  null
  
)

export default component.exports